'use strict';

'use strict';
var strictUriEncode = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

'use strict';
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

'use strict';



function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);

				key = key.replace(/\[\]$/, '');

				if (!result || accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

var extract = function (str) {
	return str.split('?')[1] || '';
};

var parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

var stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

var queryString = {
	extract: extract,
	parse: parse,
	stringify: stringify
};

function basicObjectMap() {
	var obj = Object.create(null);
	return {
		get: function(key) {
			return obj[key]
		},
		set: function(key, value) {
			obj[key] = value;
		},
		has: function(key) {
			return Object.prototype.hasOwnProperty.call(obj, key)
		},
		delete: function(key) {
			delete obj[key];
		},
		object: obj
	}
}

var keyMaster = function(factory, inputMap) {
	var map = inputMap || basicObjectMap();

	function has(key) {
		return map.has(key)
	}

	function get(key) {
		if (!map.has(key) && typeof factory === 'function') {
			map.set(key, factory(key));
		}

		return map.get(key)
	}

	function remove(key) {
		map.delete(key);
	}

	function set(key, value) {
		map.set(key, value);
	}

	function getUnderlyingDataStructure() {
		return inputMap || map.object
	}

	return {
		has: has,
		get: get,
		remove: remove,
		delete: remove,
		unset: remove,
		set: set,
		put: set,
		add: set,
		getUnderlyingDataStructure: getUnderlyingDataStructure,
	}
};

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var getPropertyValuesInOrder = function getPropertyValuesInOrder(o) {
	return Object.getOwnPropertyNames(o).map(function (key) {
		return o[key];
	});
};
var assertType = function assertType(name, value, expectedType) {
	var actualType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (actualType !== expectedType) {
		throw new Error('Expected ' + name + ' to be ' + expectedType + ' but it was ' + actualType);
	}
};

var build = function createEmitter() {
	var emitter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.create(null);

	var eventsToListeners = keyMaster(function () {
		return Object.create(null);
	});

	emitter.on = function (event, listener) {
		assertType('event', event, 'string');
		assertType('listener', listener, 'function');

		var id = Math.random().toString();
		var listeners = eventsToListeners.get(event);
		listeners[id] = listener;

		return function () {
			delete listeners[id];
		};
	};

	emitter.once = function (event, listener) {
		assertType('event', event, 'string');
		assertType('listener', listener, 'function');

		var unsubscribe = emitter.on(event, function () {
			listener.apply(undefined, arguments);
			unsubscribe();
		});

		return unsubscribe;
	};

	emitter.emit = function (event) {
		for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			args[_key - 1] = arguments[_key];
		}

		assertType('event', event, 'string');

		var listeners = eventsToListeners.get(event);
		getPropertyValuesInOrder(listeners).forEach(function (listener) {
			return listener.apply(undefined, args);
		});
	};

	return emitter;
};

var callHistoryMethod = function callHistoryMethod(method) {
	for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		args[_key - 1] = arguments[_key];
	}

	return method.apply(window.history, args);
};

function setUpListener(cb) {
	var originalPushState = window.history.pushState;
	var originalReplaceState = window.history.replaceState;

	window.history.replaceState = function () {
		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		callHistoryMethod.apply(undefined, [originalReplaceState].concat(args));
		cb();
	};

	window.history.pushState = function () {
		for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
			args[_key3] = arguments[_key3];
		}

		callHistoryMethod.apply(undefined, [originalPushState].concat(args));
		cb();
	};
}

function noop() {}

function assign(target) {
	var k,
		source,
		i = 1,
		len = arguments.length;
	for (; i < len; i++) {
		source = arguments[i];
		for (k in source) target[k] = source[k];
	}

	return target;
}

function appendNode(node, target) {
	target.appendChild(node);
}

function insertNode(node, target, anchor) {
	target.insertBefore(node, anchor);
}

function detachNode(node) {
	node.parentNode.removeChild(node);
}

function reinsertChildren(parent, target) {
	while (parent.firstChild) target.appendChild(parent.firstChild);
}

function createElement(name) {
	return document.createElement(name);
}

function createComment() {
	return document.createComment('');
}

function addListener(node, event, handler) {
	node.addEventListener(event, handler, false);
}

function removeListener(node, event, handler) {
	node.removeEventListener(event, handler, false);
}

function blankObject() {
	return Object.create(null);
}

function destroy(detach) {
	this.destroy = noop;
	this.fire('destroy');
	this.set = this.get = noop;

	if (detach !== false) this._fragment.u();
	this._fragment.d();
	this._fragment = this._state = null;
}

function differs(a, b) {
	return a !== b || ((a && typeof a === 'object') || typeof a === 'function');
}

function dispatchObservers(component, group, changed, newState, oldState) {
	for (var key in group) {
		if (!changed[key]) continue;

		var newValue = newState[key];
		var oldValue = oldState[key];

		var callbacks = group[key];
		if (!callbacks) continue;

		for (var i = 0; i < callbacks.length; i += 1) {
			var callback = callbacks[i];
			if (callback.__calling) continue;

			callback.__calling = true;
			callback.call(component, newValue, oldValue);
			callback.__calling = false;
		}
	}
}

function fire(eventName, data) {
	var handlers =
		eventName in this._handlers && this._handlers[eventName].slice();
	if (!handlers) return;

	for (var i = 0; i < handlers.length; i += 1) {
		handlers[i].call(this, data);
	}
}

function get(key) {
	return key ? this._state[key] : this._state;
}

function init(component, options) {
	component.options = options;

	component._observers = { pre: blankObject(), post: blankObject() };
	component._handlers = blankObject();
	component._root = options._root || component;
	component._yield = options._yield;
	component._bind = options._bind;
}

function observe(key, callback, options) {
	var group = options && options.defer
		? this._observers.post
		: this._observers.pre;

	(group[key] || (group[key] = [])).push(callback);

	if (!options || options.init !== false) {
		callback.__calling = true;
		callback.call(this, this._state[key]);
		callback.__calling = false;
	}

	return {
		cancel: function() {
			var index = group[key].indexOf(callback);
			if (~index) group[key].splice(index, 1);
		}
	};
}

function on(eventName, handler) {
	if (eventName === 'teardown') return this.on('destroy', handler);

	var handlers = this._handlers[eventName] || (this._handlers[eventName] = []);
	handlers.push(handler);

	return {
		cancel: function() {
			var index = handlers.indexOf(handler);
			if (~index) handlers.splice(index, 1);
		}
	};
}

function set(newState) {
	this._set(assign({}, newState));
	if (this._root._lock) return;
	this._root._lock = true;
	callAll(this._root._beforecreate);
	callAll(this._root._oncreate);
	callAll(this._root._aftercreate);
	this._root._lock = false;
}

function _set(newState) {
	var oldState = this._state,
		changed = {},
		dirty = false;

	for (var key in newState) {
		if (differs(newState[key], oldState[key])) changed[key] = dirty = true;
	}
	if (!dirty) return;

	this._state = assign({}, oldState, newState);
	this._recompute(changed, this._state);
	if (this._bind) this._bind(changed, this._state);
	dispatchObservers(this, this._observers.pre, changed, this._state, oldState);
	this._fragment.p(changed, this._state);
	dispatchObservers(this, this._observers.post, changed, this._state, oldState);
}

function callAll(fns) {
	while (fns && fns.length) fns.pop()();
}

function _mount(target, anchor) {
	this._fragment.m(target, anchor);
}

function _unmount() {
	this._fragment.u();
}

var proto = {
	destroy: destroy,
	get: get,
	fire: fire,
	observe: observe,
	on: on,
	set: set,
	teardown: destroy,
	_recompute: noop,
	_set: _set,
	_mount: _mount,
	_unmount: _unmount
};

function eventIsModifiedByKeyPress(event) {
	return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)
}
function isLeftClick(event){
	return event.button === 0
}

var clickShouldBeInterceptedForNavigation = function shouldIntercept(event) {
	return !event.defaultPrevented
		&& !eventIsModifiedByKeyPress(event)
		&& isLeftClick(event)
};

/* Link.html generated by Svelte v1.40.0 */
function querystring(parametersToQuerystring, parameters) {
	return parametersToQuerystring(parameters);
}

function hash(anchor) {
	return anchor ? '#' + anchor : '';
}

function data() {
	return {
		className: '',
		style: '',
		meta: null,
		anchor: ''
	};
}

var methods = {
	onClick: function onClick(event) {
		if (clickShouldBeInterceptedForNavigation(event)) {
			event.preventDefault();

			var _get = this.get(),
			    _querystring = _get.querystring,
			    parameters = _get.parameters,
			    meta = _get.meta,
			    _hash = _get.hash;

			this.fire('navigate', {
				querystring: _querystring,
				parameters: parameters,
				meta: meta,
				hash: _hash
			});
		}
	}
};

function create_main_fragment(state, component) {
	var if_block_anchor;

	var current_block_type = select_block_type(state);
	var if_block = current_block_type(state, component);

	return {
		c: function create() {
			if_block.c();
			if_block_anchor = createComment();
		},

		m: function mount(target, anchor) {
			if_block.m(target, anchor);
			insertNode(if_block_anchor, target, anchor);
		},

		p: function update(changed, state) {
			if (current_block_type === (current_block_type = select_block_type(state)) && if_block) {
				if_block.p(changed, state);
			} else {
				if_block.u();
				if_block.d();
				if_block = current_block_type(state, component);
				if_block.c();
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},

		u: function unmount() {
			if_block.u();
			detachNode(if_block_anchor);
		},

		d: function destroy$$1() {
			if_block.d();
		}
	};
}

// (1:0) {{#if parameters}}
function create_if_block(state, component) {
	var a,
	    a_href_value,
	    slot_content_default = component._slotted.default;

	function click_handler(event) {
		component.onClick(event);
	}

	return {
		c: function create() {
			a = createElement("a");
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = "" + state.querystring + state.hash;
			a.className = state.className;
			a.style.cssText = state.style;
			addListener(a, "click", click_handler);
		},

		m: function mount(target, anchor) {
			insertNode(a, target, anchor);
			component.refs.link = a;

			if (slot_content_default) {
				appendNode(slot_content_default, a);
			}
		},

		p: function update(changed, state) {
			if ((changed.querystring || changed.hash) && a_href_value !== (a_href_value = "" + state.querystring + state.hash)) {
				a.href = a_href_value;
			}

			if (changed.className) {
				a.className = state.className;
			}

			if (changed.style) {
				a.style.cssText = state.style;
			}
		},

		u: function unmount() {
			detachNode(a);

			if (slot_content_default) {
				reinsertChildren(a, slot_content_default);
			}
		},

		d: function destroy$$1() {
			removeListener(a, "click", click_handler);
			if (component.refs.link === a) component.refs.link = null;
		}
	};
}

// (11:0) {{else}}
function create_if_block_1(state, component) {
	var a,
	    slot_content_default = component._slotted.default;

	return {
		c: function create() {
			a = createElement("a");
			this.h();
		},

		h: function hydrate() {
			a.className = state.className;
			a.style.cssText = state.style;
		},

		m: function mount(target, anchor) {
			insertNode(a, target, anchor);

			if (slot_content_default) {
				appendNode(slot_content_default, a);
			}
		},

		p: function update(changed, state) {
			if (changed.className) {
				a.className = state.className;
			}

			if (changed.style) {
				a.style.cssText = state.style;
			}
		},

		u: function unmount() {
			detachNode(a);

			if (slot_content_default) {
				reinsertChildren(a, slot_content_default);
			}
		},

		d: noop
	};
}

function select_block_type(state) {
	if (state.parameters) return create_if_block;
	return create_if_block_1;
}

function Link(options) {
	init(this, options);
	this.refs = {};
	this._state = assign(data(), options.data);
	this._recompute({ parametersToQuerystring: 1, parameters: 1, anchor: 1 }, this._state);

	this._slotted = options.slots || {};

	this.slots = {};

	this._fragment = create_main_fragment(this._state, this);

	if (options.target) {
		this._fragment.c();
		this._fragment.m(options.target, options.anchor || null);
	}
}

assign(Link.prototype, methods, proto);

Link.prototype._recompute = function _recompute(changed, state) {
	if (changed.parametersToQuerystring || changed.parameters) {
		if (differs(state.querystring, state.querystring = querystring(state.parametersToQuerystring, state.parameters))) changed.querystring = true;
	}

	if (changed.anchor) {
		if (differs(state.hash, state.hash = hash(state.anchor))) changed.hash = true;
	}
};

function defaultReplaceState(state, title, url) {
	history.replaceState(state, title, url);
}

function defaultPushState(state, title, url) {
	history.pushState(state, title, url);
}

function defaultCurrentQuerystring() {
	var querystring = location.search;

	return {
		querystring: querystring,
		parameters: queryString.parse(querystring)
	};
}

function defaultOnPopState(listener) {
	window.addEventListener('popstate', listener);
}

function parametersToQuerystring(parameters) {
	return '?' + queryString.stringify(parameters);
}

function optionsWithAugmentedData(options) {
	return Object.assign({}, options, {
		data: Object.assign({}, options.data, { parametersToQuerystring: parametersToQuerystring })
	});
}

var stripOctothorpe = function stripOctothorpe(str) {
	return str.replace(/^#/, '');
};
var stripQuestionMark = function stripQuestionMark(str) {
	return str.replace(/^\?/, '');
};
var currentAnchor = function currentAnchor() {
	return stripOctothorpe(window.location.hash);
};
var scrollToElement = function scrollToElement(element) {
	return element && element.scrollIntoView();
};
var getElementById = function getElementById(id) {
	return id && document.getElementById(id);
};

function createRouterInstance() {
	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	var _Object$assign = Object.assign({
		pushState: defaultPushState,
		replaceState: defaultReplaceState,
		currentQuerystring: defaultCurrentQuerystring,
		onPopState: defaultOnPopState
	}, options),
	    pushState = _Object$assign.pushState,
	    replaceState = _Object$assign.replaceState,
	    currentQuerystring = _Object$assign.currentQuerystring,
	    onPopState = _Object$assign.onPopState;

	var emitter = build();

	var navigating = false;
	var handleExternalNavigation = function handleExternalNavigation() {
		if (!navigating) {
			var _currentQuerystring = currentQuerystring(),
			    querystring = _currentQuerystring.querystring,
			    parameters = _currentQuerystring.parameters;

			emitter.emit('navigate', { querystring: querystring, parameters: parameters });
		}
	};

	onPopState(handleExternalNavigation);
	setUpListener(handleExternalNavigation);

	function navigate(_ref) {
		var querystring = _ref.querystring,
		    parameters = _ref.parameters,
		    element = _ref.element,
		    meta = _ref.meta,
		    replace = _ref.replace,
		    _ref$hash = _ref.hash,
		    hash = _ref$hash === undefined ? '' : _ref$hash;

		if (typeof querystring === 'undefined') {
			querystring = parametersToQuerystring(parameters);
		}

		function emit(event) {
			emitter.emit(event, {
				querystring: querystring,
				parameters: parameters,
				meta: meta,
				element: element,
				hash: hash
			});
		}

		var navigateFunction = replace ? replaceState : pushState;

		emit('before navigate');

		emit('navigate');

		navigating = true;

		var _currentQuerystring2 = currentQuerystring(),
		    startQuerystring = _currentQuerystring2.querystring;

		var startAnchor = currentAnchor();
		if (stripQuestionMark(startQuerystring) !== stripQuestionMark(querystring)) {
			navigateFunction(parameters, '', querystring + hash);
		} else if (stripOctothorpe(hash) !== currentAnchor()) {
			pushState(parameters, '', hash);
		}

		if (currentAnchor() !== startAnchor) {
			scrollToElement(getElementById(stripOctothorpe(hash)));
		}
		navigating = false;

		emit('after navigate');
	}

	return {
		navigate: navigate,
		Link: function linkProxy(options) {
			var linkComponent = new Link(optionsWithAugmentedData(options));

			linkComponent.on('navigate', function (_ref2) {
				var querystring = _ref2.querystring,
				    parameters = _ref2.parameters,
				    meta = _ref2.meta,
				    hash = _ref2.hash;

				navigate({
					querystring: querystring,
					parameters: parameters,
					meta: meta,
					element: linkComponent.refs.link,
					hash: hash
				});
			});

			return linkComponent;
		},
		attachQuerystringData: function attachQuerystringData(component) {
			var removeListener = emitter.on('navigate', function (_ref3) {
				var parameters = _ref3.parameters;

				component.set({
					querystringParameters: parameters
				});
			});
			component.on('destroy', removeListener);
			component.set({
				querystringParameters: currentQuerystring().parameters
			});
		},
		on: function on(event, listener) {
			return emitter.on(event, listener);
		},
		once: function once(event, listener) {
			return emitter.once(event, listener);
		},
		getCurrentQuerystring: function getCurrentQuerystring() {
			return currentQuerystring().querystring;
		},
		getCurrentParameters: function getCurrentParameters() {
			return currentQuerystring().parameters;
		}
	};
}

var index = createRouterInstance();

module.exports = index;
//# sourceMappingURL=bundle.js.map
